import routes from './routes';
import sagas from './sagas';
import reducer from './reducer';

const addModule = {
  routes,
  sagas,
  reducer,
};
export default addModule;

export const allRolePermissionKeys = [
  'dashboard',
  'session',
  'detection',
  'zones',
  'system_events',
  'metrology',
  'settings',
  'settings_camera',
  'settings_complex',
  'settings_presets',
  'settings_analysts',
  'settings_export',
  'settings_user',
  'settings_wanted',
  'settings_violation',
  'settings_calibration',
  'settings_gps',
];
